import PropTypes from 'prop-types';

const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const offerSchema = PropTypes.shape({
    amount: PropTypes.number,
    annualPercentageRate: PropTypes.number,
    finalPaymentAmount: PropTypes.number,
    totalPayments: PropTypes.number,
    duration: PropTypes.number,
    originationFeeRate: PropTypes.number,
    qlDiscount: PropTypes.number,
    amountFinanced: PropTypes.number,
    rate: PropTypes.number,
    monthlyPayment: PropTypes.number,
    loanGrade: PropTypes.string,
    loanOptionDescriptor: PropTypes.string,
    financeCharge: PropTypes.number,
    originationFee: PropTypes.number,
    tag: PropTypes.string,
    postCloseDti: PropTypes.number,
    postCloseAllInDti: PropTypes.number,
});

const offerKeySchemaFactory = function (isRequired) {
    return function (props, propName, componentName) {
        const key = props[propName];

        if (!key && isRequired)
            return new TypeError(
                `${propName} must be supplied to ${componentName}. It is required`
            );
        const pass = uuidRegex.test(key);

        if (!pass) {
            return new TypeError(
                `Invalid prop ${propName} supplied to ${componentName}. Must be a UUID. Validation failed.`
            );
        }
    };
};

export const offerKeySchema = {
    isRequired: offerKeySchemaFactory(true),
};

export const offersSchema = PropTypes.shape({
    lowestRate: offerSchema,
    lowestPayment: offerSchema,
    sortedOffers: PropTypes.arrayOf(offerSchema)
});

export const offersSchemaGroup = PropTypes.objectOf(offerSchema);
export const offersSchemaGroups = PropTypes.objectOf(offersSchemaGroup);
